import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const languages = {
	"pt-BR": {
		components: {
			InputDefault: {
				placeholderCpf: "digite o seu CPF",
				backOption: "voltar"
			},
			FormLogin: {
				button_outline1_text: "cadastre-se com seu e-mail",
				input_pass_placeholder: "senha",
				button_login: "entrar",
				button_outline2_text: "esqueci minha senha",
				loader: "Logando...",
				messagesError: [
					{
						message: "Preencha os campos de e-mail e senha.",
						buttonText: "Preencher campos"
					},
					{
						message:
							"Usuário não encontrado. Verifique se você digitou o seu e-mail corretamente.",
						buttonText: "Verificar e-mail"
					},
					{
						message: "Sua senha está errada, tente novamente.",
						buttonText: "Verificar senha"
					},
					{
						message:
							"O e-mail que você digitou, não é um e-mail valido. Verifique seu e-mail.",
						buttonText: "Verificar email"
					},
					{
						message: "Houve um problema com o seu login. Tente novamente.",
						buttonText: "Tentar novamente"
					},
					{
						message: "Email e/ou senha inválidos",
						buttonText: "Tentar novamente"
					}
				]
			}
		},
		views: {
			AccessOption: {
				option_button1: "criar conta",
				option_button2: "entrar",
				copyright: "um produto",
				alertErrorInfo: {
					titleText:
						"Workspace não existe, entre em contato conosco através do e-mail huddle@huddlebrasil.com",
					nameButton: "Me tire daqui"
				},
				titleText: [
					"Ops, você está tentando acessar o game depois do prazo estipulado :/",
					"Ops, você está tentando acessar o game antes do prazo estipulado :/"
				]
			},
			ResetPasswordEmail: {
				title: "Vamos resetar a sua senha? - Huddle Brasil",
				subject: "Vamos resetar a sua senha? - Huddle Brasil",
				image: "https://i.imgur.com/qy1qsgk.jpg",
				bodyText: [
					"Olá, {userName}! Tudo bem?",
					"Esqueceu sua senha? Não se preocupe, clique no botão abaixo para redefini-la!",
					"REDEFINIR SENHA",
					"Ou acesse o link: ",
					"Após a troca, recomendamos que você não conte o seu login e senha para ninguém, essas informações são só suas, garanta a segurança dos seus dados.",
					"Por favor, não responda este e-mail, ele foi gerado automaticamente. Qualquer dúvida, entre em contato com nosso canal de suporte no "
				]
			},
			ForgotPass: {
				contentTitle: "Recuperar senha",
				titleLogin: "digite o seu e-mail para recuperar a senha",
				buttonName: "recuperar",
				messages: [
					{
						messageErrorForgot: "O e-mail está em branco, digite o seu e-mail.",
						buttonText: "Digitar e-mail"
					},
					{
						messageErrorForgot:
							"Você digitou um e-mail invalido. Verifique o seu e-mail.",
						buttonText: "Verificar e-mail"
					},
					{
						messageErrorForgot: "Usuário não encontrado. Verifique o seu e-mail.",
						buttonText: "Verificar e-mail"
					},
					{
						messageErrorForgot: "Houve um problema ao recuperar sua senha. Entre em contato: support@huddlebrasil.zendesk.com",
						buttonText: "Entrar em contato"
					}
				]
			},
			ForgotPassEmail: {
				contentTitle: "Nova senha",
				titleLogin: "Digite e confirme a sua nova senha",
				inputsPlaceholder: ["Nova senha", "Confirme a senha"],
				button: "Salvar",
				messageErrorForgotEmail: "Houve um erro ao salvar a sua senha. Tente novamente."
			},
			ForgotPassSuccess: {
				nameButton: "Realizar o Login",
				title: "A sua senha foi alterada com sucesso! :)"
			},
			SendForgotPassSuccess: {
				nameButton: "Realizar o Login",
				title: "Um e-mail foi enviado com instruções para alterar sua senha! :)"
			},
			InfosRegister: {
				contentTitle: "Finalizar cadastro",
				titleLogin: "Preencha essas informações para finalizar o cadastro",
				inputsPlaceholder: ["Digite seu nome", "Digite seu cpf"],
				button: "Cadastrar"
			},
			RegisterByEmail: {
				contentTitle: "Cadastro",
				titleLogin: "Preencha os campos para realizar o seu cadastro:",
				button_outline_text: "já possui cadastro? acesse sua conta",
				inputsPlaceholder: [
					"Digite seu nome",
					"Digite seu cpf",
					"e-mail",
					"confirme o e-mail",
					"senha",
					"confirme a senha"
				],
				button: "Cadastrar",
				loader: "estamos criando sua conta",
				messagesError: [
					{
						message: "Os e-mails não coincidem. Verifique os e-mails digitados.",
						buttonText: "Verificar e-mails"
					},
					{
						message: "As senhas não coincidem. Digite novamente as senhas.",
						buttonText: "Digitar senhas"
					},
					{
						message:
							"Você esqueceu de preencher algum dos campos. Preencha todos os campos",
						buttonText: "Preencher campos"
					},
					{
						message: "A sua senha precisa ter pelo menos 6 caracteres.",
						buttonText: "Alterar senha"
					},
					{
						message:
							"O e-mail que você digitou, não é um e-mail valido. Verifique seu e-mail.",
						buttonText: "Verificar e-mail"
					},
					{
						message:
							"O e-mail que você digitou, já possui cadastro. Utilize um outro e-mail.",
						buttonText: "Trocar e-mail"
					},
					{
						message: "Houve um problema com o seu cadastro. Tente novamente.",
						buttonText: "Tentar novamente"
					}
				],
				RegisterSuccess: {
					nameButton: "Próxima etapa",
					title: "O seu cadastro foi concluído com sucesso! :)"
				},
				SendForgotSuccess: {
					nameButton: "Voltar para o Login",
					title:
						"O e-mail de recuperação de senha foi enviado! Verifique sua caixa de e-mail. :)"
				}
			}
		}
	},
	"en-US": {
		components: {
			InputDefault: {
				placeholderCpf: "Type in your ID",
				backOption: "back"
			},
			FormLogin: {
				button_outline1_text: "Sign up with your e-mail",
				input_pass_placeholder: "password",
				button_login: "Log in",
				button_outline2_text: "forgot my password",
				loader: "Logging in.",
				messagesError: [
					{
						message: "Fill in the e-mail and password",
						buttonText: "Fill in the fields"
					},
					{
						message:
							"User not found. Make sure you typed your email correctly.",
						buttonText: "Check e-mail"
					},
					{
						message: "Your password is wrong, please try again.",
						buttonText: "Verify password"
					},
					{
						message:
							"The email you entered is not a valid email. Check your email.",
						buttonText: "Verify e-mail"
					},
					{
						message: "There was a problem with your login. Try again.",
						buttonText: "Try again"
					}
				]
			}
		},
		views: {
			AccessOption: {
				option_button1: "Sign up",
				option_button2: "log in",
				copyright: "a product by",
				alertErrorInfo: {
					titleText:
						"Workspace does not exist, contact us at huddle@huddlebrasil.com",
					nameButton: "Take my out of here"
				},
				titleText: [
					"Oops, you are trying to access the game after the deadline: /",
					"Oops, you are trying to access the game before the deadline: /"
				]
			},
			ResetPasswordEmail: {
				title: "Let's reset your password - Huddle Brasil",
				subject: "Let's reset your password - Huddle Brasil",
				image: "https://i.imgur.com/DiUvJl1.png",
				bodyText: [
					"Hello, {userName}! All good?",
					"Forgot your password? Don't worry, click the button bellow to reset it!",
					"RESET PASSWORD",
					"Or access the link: ",
					"After the change, we recommend that you do not tell your login and password to anyone, this information is yours alone. Guarantee the security of your data.",
					"Please do not reply to this email, it was automatically generated. Any questions, please contact our support channel at "
				]
			},
			ForgotPass: {
				contentTitle: "Recover password",
				titleLogin: "enter your email to recover your password",
				buttonName: "to recover",
				messages: [
					{
						messageErrorForgot: "Email is blank, enter your email.",
						buttonText: "Enter e-mail"
					},
					{
						messageErrorForgot:
							"You entered an invalid email. Check your email.",
						buttonText: "Verify e-mail"
					},
					{
						messageErrorForgot: "User not found. Check your email.",
						buttonText: "Verify e-mail"
					},
					{
						messageErrorForgot: "There was a problem retrieving your password. Contact: support@huddlebrasil.zendesk.com",
						buttonText: "Contact support"
					}
				]
			},
			ForgotPassEmail: {
				contentTitle: "New password",
				titleLogin: "type and confirm your new password.",
				inputsPlaceholder: ["New password", "Confirm the passowrd"],
				button: "Save",
				messageErrorForgotEmail: "There was an error saving your password. Try again."
			},
			ForgotPassSuccess: {
				nameButton: "Login",
				title: "Your password was successfully changed! :)"
			},
			SendForgotPassSuccess: {
				nameButton: "Login",
				title: "An email has been sent with instructions to change your password! :)"
			},
			InfosRegister: {
				contentTitle: "Finish registration",
				titleLogin: "Fill in this information to complete the registration",
				inputsPlaceholder: ["Type your name", "Type in cpf"],
				button: "Cadastrar"
			},
			RegisterByEmail: {
				contentTitle: "register",
				titleLogin: "Fill in the fields to register",
				button_outline_text: "already registered? access your account",
				inputsPlaceholder: [
					"Type in your name",
					"Type your ID",
					"e-mail",
					"confirm e-mail",
					"password",
					"confirm password"
				],
				button: "Register",
				loader: "we are creating your account",
				messagesError: [
					{
						message: "The emails doesn't match. Check typed emails.",
						buttonText: "Verify e-mails"
					},
					{
						message: "Passwords do not match. Retype passwords.",
						buttonText: "Enter passwords"
					},
					{
						message:
							"You forgot to fill in some fields. Fill in all fields",
						buttonText: "Fill in fields"
					},
					{
						message: "Your password must be at least 6 characters long.",
						buttonText: "Change Password"
					},
					{
						message:
							"The email you entered is not a valid email. Check your email.",
						buttonText: "Verify e-mail"
					},
					{
						message:
							"The email you entered was already registrated. Use another email.",
						buttonText: "Change e-mail"
					},
					{
						message: "There was a problem with your registration. Try again.",
						buttonText: "Try again"
					}
				],
				RegisterSuccess: {
					nameButton: "Next step",
					title: "Your registration was completed successfully! :)"
				},
				SendForgotSuccess: {
					nameButton: "Go Back to Login",
					title:
						"The password recovery email has been sent! Check your email box. :)"
				}
			}
		}
	},
	"es": {
		components: {
			InputDefault: {
				placeholderCpf: "Ingrese su NIF",
				backOption: "volver"
			},
			FormLogin: {
				button_outline1_text: "Regístrese con su correo electrónico",
				input_pass_placeholder: "clave",
				button_login: "entrar",
				button_outline2_text: "olvidé mi clave",
				loader: "Iniciando sesión...",
				messagesError: [
					{
						message: "Rellene los campos de correo electrónico y clave.",
						buttonText: "Rellenar campos"
					},
					{
						message:
							"Usuario no encontrado. Verifique si ha ingresado el correo electrónico correctamente.",
						buttonText: "Verificar correo electrónico"
					},
					{
						message: "Su clave es incorrecta, vuelva a intentarlo.",
						buttonText: "Verificar clave"
					},
					{
						message:
							"El correo electrónico que ha ingresado no es un correo electrónico válido. Verifique seu correo electrónico.",
						buttonText: "Verificar correo electrónico"
					},
					{
						message: "Hubo un problema con su acceso. Vuelva a intentarlo.",
						buttonText: "Intente nuevamente"
					},
					{
						message: "Correo electrónico y/o clave incorrectos",
						buttonText: "Intente nuevamente"
					}
				]
			}
		},
		views: {
			AccessOption: {
				option_button1: "crear cuenta",
				option_button2: "entrar",
				copyright: "un producto",
				alertErrorInfo: {
					titleText:
						"Workspace no existe, contáctenos a través del correo electrónico huddle@huddlebrasil.com",
					nameButton: "Sácame de aquí"
				},
				titleText: [
					"Ups, usted está intentando acceder al game después del plazo estipulado :/",
					"Ups, usted está intentando acceder al game antes del plazo estipulado :/"
				]
			},
			ResetPasswordEmail: {
				title: "Vamos a restablecer tu contraseña - Huddle Brasil",
				subject: "Vamos a restablecer tu contraseña - Huddle Brasil",
				image: "https://i.imgur.com/LjAcLDb.png",
				bodyText: [
					"Hola, {userName}! Todo está bien?",
					"¿Olvidaste tu contraseña? ¡No se preocupe, haga clic en el botón de abajo para restablecerlo!",
					"RESTABLECER LA CONTRASEÑA",
					"O accede al enlace: ",
					"Después del cambio, le recomendamos que no le diga a nadie su nombre de usuario y contraseña, esta información es solo suya. Garantice la seguridad de sus datos.",
					"Por favor, no responda a este correo electrónico, se generó automáticamente. Cualquier pregunta, por favor póngase en contacto con nuestro canal de soporte en "
				]
			},
			ForgotPass: {
				contentTitle: "Recuperar clave",
				titleLogin: "Ingrese su correo electrónico para recuperar la clave",
				buttonName: "recuperar",
				messages: [
					{
						messageErrorForgot: "El correo electrónico está en blanco, ingrese su correo electrónico.",
						buttonText: "Ingresar correo electrónico"
					},
					{
						messageErrorForgot:
							"Ha ingresado un correo electrónico no válido. Verifique su correo electrónico.",
						buttonText: "Verificar correo electrónico"
					},
					{
						messageErrorForgot: "Usuario no encontrado. Verifique su correo electrónico.",
						buttonText: "Verificar correo electrónico"
					},
					{
						messageErrorForgot: "Hubo un problema al recuperar su clave. Entre en contacto: support@huddlebrasil.zendesk.com",
						buttonText: "Entrar en contacto"
					}
				]
			},
			ForgotPassEmail: {
				contentTitle: "Nueva clave",
				titleLogin: "Ingrese y confirme su nueva clave",
				inputsPlaceholder: ["Nueva clave", "Confirme la clave"],
				button: "Guardar",
				messageErrorForgotEmail: "Hubo un error al guardar su clave. Vuelva a intentarlo."
			},
			ForgotPassSuccess: {
				nameButton: "Realizar acceso",
				title: "¡Su clave ha sido cambiada con éxito! :)"
			},
			SendForgotPassSuccess: {
				nameButton: "Realizar acceso",
				title: "¡Ha sido enviado un correo electrónico con instrucciones para cambiar su clave! :)"
			},
			InfosRegister: {
				contentTitle: "Finalizar el registro",
				titleLogin: "Rellene esas informaciones para finalizar el registro",
				inputsPlaceholder: ["Ingrese su nombre", "Ingrese su nif"],
				button: "Registrar"
			},
			RegisterByEmail: {
				contentTitle: "Registro",
				titleLogin: "Rellene los campos para realizar su registro:",
				button_outline_text: "¿ya posee registro? accese su cuenta",
				inputsPlaceholder: [
					"Ingrese su nombre",
					"Ingrese su nif",
					"correo electrónico",
					"confirme su correo electrónico",
					"clave",
					"confirme su clave"
				],
				button: "Registrar",
				loader: "estamos creando su cuenta",
				messagesError: [
					{
						message: "Los correos electrónicos no coinciden. Verifique los correos electrónicos ingresados",
						buttonText: "Verificar correos electrónicos"
					},
					{
						message: "Las claves no coinciden. Vuelva a ingresar las claves.",
						buttonText: "Ingresar claves"
					},
					{
						message:
							"Ha olvidado de rellenar alguno de los campos. Rellene todos los campos",
						buttonText: "Renellar campos"
					},
					{
						message: "Su clave debe tener al menos 6 caracteres",
						buttonText: "Cambiar clave"
					},
					{
						message:
							"El correo electrónico que ha ingresado no es un correo electrónico válido.  Verifique su correo electrónico.",
						buttonText: "Verificar correo electrónico"
					},
					{
						message:
							"El correo electrónico que ha ingresado ya posee registro. Utilice un otro correo electrónico.",
						buttonText: "Cambiar correo electrónico"
					},
					{
						message: "Hubo un problema con su registro. Vuelva a intentar.",
						buttonText: "Intentar nuevamente"
					}
				],
				RegisterSuccess: {
					nameButton: "Siguiente paso",
					title: "¡Su registro ha sido realizado con éxito! :)"
				},
				SendForgotSuccess: {
					nameButton: "Volver al Acceso",
					title:
						"¡Se ha enviado un correo electrónico de recuperación de clave! Revise su bandeja de entrada de correo electrónico :)"
				}
			}
		}
	}
};

const i18n = new VueI18n({
	locale: "pt-BR", // set locale
	fallbackLocale: "pt-BR", // set fallback locale
	messages: languages // set locale messages
});

export default i18n;
